module.exports = __webpack_public_path__ + "img/tribeidblack-min (1).d767bde9.png";